module.exports = __webpack_public_path__ + "img/footer-website.515949ed.jpg";